import React from 'react';
import PropTypes from 'prop-types';

import {
	MInputField,
	MRte,
} from '../../molecules';

export default function OProjectenBasicInfo({
	name,
	slug,
	disableName,
	disableSlug,
	description,
	seoTitle,
	seoDescription,
	onNameChange,
	onSlugChange,
	onDescriptionChange,
	onSeoTitleChange,
	onSeoDescriptionChange,
}) {
	return (
		<section className="o-product-detail-info">
			<MInputField
				id="pbiTitle"
				label="Title"
				value={name}
				required
				disabled={disableName}
				onChange={onNameChange}
				maxLength="45"
			/>
			<MInputField
				id="pbiSlug"
				label="Slug"
				value={slug}
				required
				disabled={disableSlug}
				onChange={onSlugChange}
			/>
			<MRte
				id="pbiDescription"
				label="Beschrijving"
				value={description}
				required
				onChange={onDescriptionChange}
			/>
			<MInputField
				id="seoTitle"
				label="SEO titel (optioneel)"
				value={seoTitle}
				onChange={onSeoTitleChange}
				maxLength="60"
			/>
			<MInputField
				id="seoDescription"
				label="SEO omschrijving (optioneel)"
				value={seoDescription}
				onChange={onSeoDescriptionChange}
				maxLength="160"
			/>
		</section>
	);
}

OProjectenBasicInfo.propTypes = {
	name: PropTypes.string,
	slug: PropTypes.string,
	seoTitle: PropTypes.string,
	seoDescription: PropTypes.string,
	disableName: PropTypes.bool,
	disableSlug: PropTypes.bool,
	description: PropTypes.string,
	onNameChange: PropTypes.func,
	onSlugChange: PropTypes.func,
	onDescriptionChange: PropTypes.func,
	onSeoTitleChange: PropTypes.func,
	onSeoDescriptionChange: PropTypes.func,
};

OProjectenBasicInfo.defaultProps = {
	name: '',
	slug: '',
	disableName: false,
	disableSlug: false,
	description: '',
	seoTitle: '',
	seoDescription: '',
	onNameChange: undefined,
	onSlugChange: undefined,
	onDescriptionChange: undefined,
	onSeoTitleChange: undefined,
	onSeoDescriptionChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.projecten-basic-info.js